import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const FAQSection: React.FC = () => {
  const { t } = useTranslation();
  const headerRef = useScrollAnimation<HTMLDivElement>();
  const listRef = useScrollAnimation<HTMLDivElement>(0.1);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = t('faq.items', { returnObjects: true }) as { q: string; a: string }[];

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="hp-faq" aria-labelledby="faq-title">
      <div className="hp-faq-inner">
        <div ref={headerRef} className="hp-section-header hp-animate">
          <span className="hp-section-label">{t('faq.sectionLabel')}</span>
          <h2 id="faq-title">{t('faq.title')}</h2>
          <p>{t('faq.subtitle')}</p>
        </div>

        <div ref={listRef} className="hp-faq-list hp-animate">
          {faqs.map((faq, i) => (
            <div key={i} className={`hp-faq-item${openIndex === i ? ' hp-faq-item--open' : ''}`}>
              <button
                className="hp-faq-question"
                onClick={() => toggle(i)}
                aria-expanded={openIndex === i}
                aria-controls={`faq-answer-${i}`}
              >
                {faq.q}
                <span className="hp-faq-toggle-icon" aria-hidden="true"
                  style={{ transform: openIndex === i ? 'rotate(180deg)' : 'rotate(0deg)' }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </button>
              <div
                id={`faq-answer-${i}`}
                className="hp-faq-answer-wrapper"
                role="region"
              >
                <div className="hp-faq-answer">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
